module.exports = __webpack_public_path__ + "static/media/CeraPro-Bold.ec83179a.eot";